import { ThreeView } from "../View3dWebCad";
import * as THREE from 'three';


export class wallEffect {
    private objects: THREE.Mesh[];
    private materials: THREE.Material[];
    // private t0: number;

    // private delay: number = 300;

    constructor() {
        this.objects = [];
        this.materials = [];
    }

    public select(guid: string, checkFunc: (obj: THREE.Object3D) => boolean = undefined) {

        if (!guid || guid.length <= 0) return;

        if (this.objects.length> 0) {
            this.repairMaterial();
        }
        this.objects = this.findObjectFromGUID(guid, checkFunc);

        if (this.objects.length == 0) return;

        this.materials = [];

        this.objects.forEach((obj) => this.setMaterial(obj));
    }

    private findObjectFromGUID(guid: string, checkFunc): THREE.Mesh[] {
        
        const objects: THREE.Mesh[] = [];

        ThreeView.get().wcScene.me.traverse((object: THREE.Object3D) => {
            if (checkFunc && checkFunc(object) == false) return;
            const mesh = <THREE.Mesh>object;
            if (!mesh.isMesh) return;

            if (mesh.userData.modelInfo && mesh.userData.modelInfo.uuid) {
                if (object.userData.modelInfo.uuid == guid) {
                    objects.push(mesh);
                }
            }
            if (object.userData.guid && object.userData.guid == guid) {
                objects.push(mesh);
            }
        });
        return objects;
    }

    // バックアップを元に戻す
    private repairMaterial() {
        this.objects.forEach((obj, index) => {
            obj.material = this.materials[index];
        });
    }

    public unselect() {
        if (this.objects.length> 0) {
            this.repairMaterial();
        }
        this.objects = [];
        this.materials = [];
    }
    
    // 元のマテリアルのバックアップ
    private setMaterial(object: THREE.Mesh) {
        this.materials.push(<THREE.Material>object.material);
        object.material = new THREE.MeshBasicMaterial({color:0xFE6E00, toneMapped: false});
        object.material.userData.select = true;
    }

    public match(object: THREE.Mesh) {
        const mat = Array.isArray(object.material) ? object.material : [object.material];

        for ( let i = 0; i < mat.length; i++) {
            if (mat[i].userData.select == true) {
                return true;
            }
        }
        return false;
    }

    // public update() {
    //     const t1 = performance.now();
    //     if (this.t0 + this.delay > t1) return true;

    //     this.obj1.material = this.mat1;
    //     this.obj2.material = this.mat2;

    //     return false;
    // }

    private isWallType = (name: string): boolean => {
        return name.match(/^rom.*-wall-node/) != null;
    }

    private findkosiNode = (name: string): THREE.Object3D => {
        return ThreeView.get().wcItemmgr.houseObjects.getObjectByName(name.replace('wall', 'kosi'));
    }
    private findwallNode = (name: string): THREE.Object3D => {
        return ThreeView.get().wcItemmgr.houseObjects.getObjectByName(name.replace('kosi', 'wall'));
    }

}
